import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { MainService } from 'src/app/Service/main.service';
import { DataService } from 'src/app/Service/data.service';
import { ConfirmDialogService } from 'src/app/adminUsers/confirm-dialog/confirm-dialog.service';
import { environment } from '../../../environments/environment.prod';

@Component({
  selector: 'app-tenant-settings',
  templateUrl: './tenant-settings.component.html',
  styleUrls: ['./tenant-settings.component.scss']
})
export class TenantSettingsComponent implements OnInit {
  expiryDate = new Date();
  expiryDate1 = new Date();
  FeedbackForm = true;
  AdditionalForm = false;
  response: any;
  dvID: any;

  constructor( private fb: FormBuilder, private route: Router, private confirmDialogService: ConfirmDialogService, private mainService: MainService, private dataService: DataService ) { }

//   ngOnInit(): void {

//   // const queryString = encodeURIComponent(JSON.stringify(data));

//   //   //Url wil be docuverus home page
//   //   const url=`https://test-app.dvapply.com/atss/dashboard/subscriberLogin/subData=${queryString}`;
//   //   window.open(url, "_blank");

//   this.verifySubscriberLogin();

//     this.route.navigate(['/home'])
//   }
// }

ngOnInit(): void {
  this.verifySubscriberLogin();
  this.route.navigate(['/home']);
}

verifySubscriberLogin(): void {
  const userToken = this.dataService.getUserToken();

  const subscriberLogin  = JSON.parse(sessionStorage.getItem('subscriberLogin'));
  const sbId = subscriberLogin.Data.id;

  const subIdNew = {
    subscriberId : sbId
  };

  const obj = this;

  this.dataService.getDvId('admin/user/getSubscriberData', subIdNew, userToken).subscribe((res: any) => {
    console.log('testone', res);
    this.response = res;
    if (this.response.Status === 200) {
      const requestBody = {
        subscriberID: res.Data[0].dvID
      };

      this.dataService.verifySubscriber(
        'docuverus-service/validate-subscriber',
        requestBody,
        userToken
      ).subscribe(
        (res) => {
          this.response = res;
          if (this.response.Status === 200) {
            console.log('response', this.response, this.response.Data);
            const subUserId = this.response.Data?.userid;
            const queryString = encodeURIComponent(JSON.stringify(this.response.Data));

            const url = environment.dvDataUrl + `atss/dashboard/subscriberLogin/${queryString}`;

            window.open(url, '_blank');
          } else {
            console.error('Error:', this.response.Message);
            this.mainService.ShowAlert('Error', this.response.Message);
          }
        },
        (err) => {
          console.error('Error:', err);
        }
      );
    }else {
      console.error('Error:', this.response.Message);
      this.mainService.ShowAlert('Error', this.response.Message);
    }

    }, err => {

    });

}
}

